import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "entity-chat-ui-button",
  {
    variants: {
      variant: {
        default: "entity-chat-ui-button-default",
        destructive: "entity-chat-ui-button-destructive",
        outline: "entity-chat-ui-button-outline",
        secondary: "entity-chat-ui-button-secondary",
        ghost: "entity-chat-ui-button-ghost",
        link: "entity-chat-ui-button-link",
      },
      size: {
        default: "entity-chat-ui-button-default-size",
        sm: "entity-chat-ui-button-sm",
        lg: "entity-chat-ui-button-lg",
        icon: "entity-chat-ui-button-icon",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
  VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        type={asChild ? undefined : 'button'}
        className={cn(buttonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }

